import classNames from "classnames";

/**
 * Renders out a table from a tablefield type.
 *
 * @param rows
 * @constructor
 */
export function WidgetTableField({ rows, keyPrefix }: {rows: {[key:string]: string}[], keyPrefix: string}) {
  if (rows?.length <= 1 || !rows?.length) return <></>
  rows = rows.sort((a: any, b: any) => a?.weight - b?.weight);
  const header = rows?.[0];
  // Filter empty rows.
  let tableRows = rows?.length ? rows.slice(1).filter(row => !!Object.keys(row).filter((key) => !isNaN(parseFloat(key)) && row[key])?.length) : [];
  if (!tableRows?.length) return <></>

  return (
    <div className={classNames("container pb-6 mx-auto w-full")}>
      <table className="block w-full table-auto overflow-auto max-h-[70vh] md:max-h-none">
        {header ? (
          <thead className="sticky top-0">
            <tr>
              {Object.keys(header).map((item, key) => {
                if (isNaN(parseFloat(item))) return;
                return (
                  // Force the second column to be the largest.
                  <th className={classNames("text-left bg-white p-2 font-bold border-b-light border-b-4 min-w-[150px]", {"w-[75%]": key === 1})} key={`widget--table-field--${keyPrefix}--header--${key}`}>{header[key]}</th>
                )
              })}
            </tr>
          </thead>
        ): <></>}
        <tbody>
          {tableRows.map((row, rowKey) => (
            <tr className="" key={`widget--table-field--${keyPrefix}--row--${rowKey}`}>
              {Object.keys(row).map((item, key) => {
                if (isNaN(parseFloat(item))) return;
                return (
                  <td className={classNames(
                    "p-2",
                    {"bg-white": rowKey % 2 === 0}
                  )}
                      key={`widget--table-field--${keyPrefix}--col--${key}`}>{row[key]}</td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}